import { Grid } from "@mui/material";
import React from "react";
import VEBBeneficiary from "../../VEBBeneficiary/VEBBeneficiary";

type EditWholeLifeBeneficiary = {
	employeePrimaryBeneficiary: any;
	setEmployeePrimaryBeneficiary: any;
	childrenPrimaryBeneficiary: any;
	setChildrenPrimaryBeneficiary: any;
	spousePrimaryBeneficiary: any;
	setSpousePrimaryBeneficiary: any;

	// contingent beneficiary
	employeeContingentBeneficiary: any;
	setEmployeeContingentBeneficiary: any;
	childrenContingentBeneficiary: any;
	setChildrenContingentBeneficiary: any;
	spouseContingentBeneficiary: any;
	setSpouseContingentBeneficiary: any;
	dependents: any;
	member: any;
	spouse: any;
	coverage_for: any;
	isChild: boolean;
};

const EditWholeLifeBeneficiary: React.FC<EditWholeLifeBeneficiary> = ({
	employeePrimaryBeneficiary,
	setEmployeePrimaryBeneficiary,
	childrenPrimaryBeneficiary,
	setChildrenPrimaryBeneficiary,
	spousePrimaryBeneficiary,
	setSpousePrimaryBeneficiary,
	employeeContingentBeneficiary,
	setEmployeeContingentBeneficiary,
	childrenContingentBeneficiary,
	setChildrenContingentBeneficiary,
	spouseContingentBeneficiary,
	setSpouseContingentBeneficiary,
	dependents,
	member,
	spouse,
	coverage_for,
	isChild
}) => {
	return (
		<div>
			<Grid container justifyContent={"center"} justifyItems="center" alignItems={"center"}>
				{member &&
				(coverage_for === "Employee Only" ||
					coverage_for === "Employee & Children" ||
					coverage_for === "Employee & Spouse" ||
					coverage_for === "Employee & Family") ? (
					<Grid item xl={12} lg={12} md={12}>
						<VEBBeneficiary
							primaryBeneficiary={employeePrimaryBeneficiary}
							setPrimaryBeneficiary={setEmployeePrimaryBeneficiary}
							contingentBeneficiary={employeeContingentBeneficiary}
							setContingentBeneficiary={setEmployeeContingentBeneficiary}
							member={member}
							employee={member}
							dependents={dependents}
							// isChild={isChild}
						/>
					</Grid>
				) : null}
				{spouse &&
				(coverage_for === "Employee & Spouse" ||
					coverage_for === "Spouse Only" ||
					coverage_for === "Spouse & Children" ||
					coverage_for === "Employee & Family") ? (
					<Grid item xl={12} lg={12} md={12}>
						<div className="theme-plan-section-margin" />
						<VEBBeneficiary
							primaryBeneficiary={spousePrimaryBeneficiary}
							setPrimaryBeneficiary={setSpousePrimaryBeneficiary}
							contingentBeneficiary={spouseContingentBeneficiary}
							setContingentBeneficiary={setSpouseContingentBeneficiary}
							member={spouse}
							employee={member}
							dependents={dependents}
							// isChild={isChild}
						/>
					</Grid>
				) : null}
			</Grid>
		</div>
	);
};

export default EditWholeLifeBeneficiary;
